// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2Z6Rp","col":"CardReaderDesc_col__21Zlh","label":"CardReaderDesc_label__xuvfT"};